import React, { Component } from 'react'
import { connect } from 'react-redux';
import { setFilter } from '../../actions/filters'

// UI component for dropdown.
const QueueFilterDropdown = ({ value, handleChange }) => (
    <select value={value}
        className="form-control"
        onChange={handleChange}
    >
        <option value="">Search Queue</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
    </select>
)

// Actual class
class QueueFilter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            input1: ''
        }
        this.handleStatusFilterDropdown = this.handleStatusFilterDropdown.bind(this)
        this.clearFilter = this.clearFilter.bind(this)
    }

    clearFilter() {
        this.setState({
            input1: ''
        })
    }

    handleStatusFilterDropdown(event) {
        let newInput = event.target.value.toString()

        this.setState({
            input1: newInput
        })
    }

    componentDidUpdate() {
        this.bindToState()
    }

    componentDidMount() {
        const getPreviousValue = this.props.value1.toString()


        this.setState({
            input1: getPreviousValue
        })

    }

    bindToState() {
        let filter = {}
        filter[this.props.filterName] = {
            type: "queueEnum",
            value1: this.state.input1.toString()
        }
        this.props.dispatch(setFilter(
            this.props.id,
            filter
        ))

    }


    render() {
        // let i1 = this.props.value1
        return (
            <div className="form-group">
                <QueueFilterDropdown
                    value={this.state.input1}
                    handleChange={this.handleStatusFilterDropdown}
                />
            </div>
        )
    }
}

export default connect(null, null, null, { withRef: true })(QueueFilter)


// WEBPACK FOOTER //
// ./src/components/filters/queueFilter.js